<template>
  <div class="content-box">
    <div>
      <router-link :to="{ name: 'inventario-conteo' }" style="color: blueviolet;">
        <i class="fa fa-arrow-left"></i>
        Ver Conteos Individuales
      </router-link>
    </div>
    <br>
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Conteos de Inventario Agrupado</h5>
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-12">
              <div class="row justify-content-sm-end"></div>
              <div class="form-inline justify-content-sm-end">
                <input class="form-control form-control-sm rounded bright" placeholder="Número de conteo"
                  v-model="filter.searchtext" type="text" v-on:keyup.enter="refreshConteo()" />
                <input type="date" v-model="filter.fecha" class="form-control form-control-sm rounded bright" @change="refreshConteo()"
                  style="width: 150px" />
                <TiendaSelectComponent class="col-sm-2" _class="form-control form-control-sm rounded bright"
                  titulo="hide" style="display: block" :desblock="true" placeholder="Tienda" :current="filter"
                  @change="filterData()" @onChange="filterData()" />

                <select 
                  class="form-control form-control-sm rounded bright" 
                  v-model="filter.estado"
                  @change="refreshConteo()" style="width: 150px"
                >
                  <option value="0">Todos</option>
                  <option value="1">Abierto</option>
                  <option value="2">Finalizado</option>
                </select>

                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="button" @click="refreshConteo()">
                    <i class="fa fa-search"></i>
                  </button>
                  <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData2()">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConteoAgrupadoTableComponent :dataTabla="dataTabla" />
    </div>
    <PaginationComponent :currentPage="currentPage" :data="dataTabla" @pagechanged="refreshConteo" />
    <div class="modal fade" id="conteoAgrupadoModal" tabindex="-1" role="dialog" aria-labelledby="conteoAgrupadoModal"
      aria-hidden="true">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Seleccione la Tienda</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <TiendaSelectComponent :current="current" />
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" @click="crearConteo" class="btn btn-success btn-block">
                Crear Nuevo Conteo &nbsp;
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalTiendaSelect" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
      aria-hidden="true" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Elije una tienda</h5>
          </div>
          <div class="modal-body">
            <select class="form-control col-12" v-model="filter.tienda" @change="refreshConteo()">
              <option v-for="(item, key) in tiendas" :value="item.codigo" :key="key">
                {{ item.codigo }} - {{ item.nombre }}
              </option>
            </select>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="clearFilterData()"
              style="text-align: left;">
              <i class="fas fa-times"></i>
              Cerrar
              <br>
              <small>(Se mostrará todas las tiendas)</small>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="floated-chat-btn" @click="abrirModalCrear">
      <i class="fas fa-clipboard-check"></i>&nbsp;Nuevo Conteo
    </div>
  </div>
</template>

<script>
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ConteoAgrupadoTableComponent from "@/components/inventario/conteo_agrupado/ConteoAgrupadoTableComponent";
import DynamicService from "@/services/commons/DynamicService";
import PaginationComponent from "@/components/utils/PaginationComponent";
import Notifications from "@/notifications/notifications";
import { mapGetters } from "vuex";

export default {
  components: {
    ConteoAgrupadoTableComponent,
    TiendaSelectComponent,
    PaginationComponent,
  },
  data() {
    return {
      filter: {
        tienda: "",
        estado_str: "",
        searchtext: "",
        usuario: "",
        estado: "0",
        proveedor: "",
        fecha: "",
      },
      conteo: "",
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      posiciones: [],
      current: {},
      filtro_tienda: "",
      dataTabla: "",
      filtro_producto: "",
      _filtro_producto: "",
      producto: "",
      errors: {
        producto: "",
      },
      barra: "",
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
  },
  mounted() {
    this.$store.dispatch("catalogos/llenar_tiendas", {
      activa: true,
      quitar_paginacion: true,
    });
    this.refreshConteo();
    $("#modalTiendaSelect").modal("show");
  },
  methods: {

    /**
     * Funcion que obtiene la data de la tabla
     * filtrada o No
     */
    refreshConteo(page) {
      let fecha;
      if (this.filter.fecha) {
        fecha = moment(this.filter.fecha).format("DD/MM/YYYY");
      }
      if (page) {
        this.currentPage = page;
      }
      DynamicService.fetch("inv", "conteo-agrupado", {
        page: this.currentPage,
        "filter[search]": this.filter.searchtext,
        fecha: fecha,
        tienda: this.filter.tienda,
        numero: this.filter.numero,
      }).then((response) => {
        this.dataTabla = response.data;

        // Filtro de Estado
        if (this.filter.estado != 0) {

          // Filtro Estado Abierto
          if (this.filter.estado == 1) {
            const filteredResults = this.dataTabla.results.filter(item => item.fecha_finalizacion === null);
              this.dataTabla = {
              results: filteredResults,
              count: filteredResults.length
            };
          } 

          // Filtro Estado Finalizado
          if (this.filter.estado == 2) {
            const filteredResults = this.dataTabla.results.filter(item => item.fecha_finalizacion !== null);
              this.dataTabla = {
              results: filteredResults,
              count: filteredResults.length
            };
          }
        }
      });
      $("#modalTiendaSelect").modal("hide");
    },

    
    clearFilterData2() {
      this.filter.searchtext = "";
      this.$data.currentPage = 1;
      this.filter.tienda = "";
      this.filter.fecha = "";
      this.filter.estado = "0"
      DynamicService.fetch("inv", "conteo-agrupado", {
        page: 1,
      }).then((response) => {
        this.dataTabla = response.data;
      });
    },
    clearFilterData() {
      this.filter.searchtext = "";
      this.$data.currentPage = 1;
      this.filter.tienda = "";
      this.filter.fecha = "";
      this.filter.estado = "0"
      DynamicService.fetch("inv", "conteo-agrupado", {
        page: 1,
      }).then((response) => {
        this.dataTabla = response.data;
      });
      $("#modalTiendaSelect").modal("show");
    },
    modalTiendaSelect() {
      $("#modalTiendaSelect").modal("show");
    },
    abrirModalCrear() {
      $("#conteoAgrupadoModal").modal("show");
    },
    crearConteo() {
      DynamicService.save("inv", "conteo-agrupado", {
        tienda: this.current.tienda,
      }).then((response) => {
        this.refreshConteo();
        $("#conteoAgrupadoModal").modal("hide");
        this.$router.push({
          name: "inventario-conteo-agrupado-editar",
          params: {
            id: response.data.id,
          },
        });
      })
      .catch((error) => {
        Notifications.alert.error(
          "Crear Conteo Agrupado",
          error.response.data.detail
        );
      });
    },
  },
};
</script>
